import React from 'react';
import styled from "styled-components";
import ProfileImage from "./ProfileImage";

const Style = styled.div`
    text-align: center;
    margin-bottom: 10px;
`;

const WrapperStyled = styled.div`
    border-radius: var(--mui-shape-borderRadius);
    cursor: pointer;
    min-width: 64px;
    max-width: 90px;
    padding: 5px;
    border: 1px solid rgba(var(--mui-palette-primary-mainChannel) / 0.5);
    color: var(--mui-palette-primary-main);
    margin: auto;

    &:hover {
        background-color: rgba(var(--mui-palette-primary-mainChannel) / var(--mui-palette-action-hoverOpacity));
        border: 1px solid var(--mui-palette-primary-main);
    }

    &.active {
        color: var(--mui-palette-primary-contrastText);
        background-color: var(--mui-palette-primary-main);
    }

    .profile-image {
        display: grid;
        justify-content: center;
    }

    .shopper-name {
        margin-top: 8px;
        word-wrap: break-word;
    }
`;

const ShopperProfile = ({shopper, onClick, isActive, stats}) => {
    return (
        <Style
            onClick={onClick}
        >
            <WrapperStyled
                data-shopper={shopper._id}
                className={isActive ? "active" : ""}>
                <ProfileImage
                    imageUrl={shopper.imageUrl}
                    name={shopper.name}
                />
                <div className="shopper-name">
                    {shopper.name}
                </div>
            </WrapperStyled>
            {
                stats ? stats : <></>
            }
        </Style>
    );
};

export default ShopperProfile;